import React, { createContext, useState, useContext, useEffect } from 'react';
import axios from 'axios';


const AuthContext = createContext();
const LoadingContext = createContext(); 


export const useAuth = () => {
  return useContext(AuthContext);
};


export const useLoading = () => {
  return useContext(LoadingContext);
};


export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(false); 

  useEffect(() => {
    const fetchUserData = async () => {
      setLoading(true);
      const token = localStorage.getItem('token');
      if (token) {
        try {
          // Fetch user data with role populated
          const response = await axios.get('/user/me', {
            headers: { Authorization: `Bearer ${token}` }
          });
          setUser(response.data);
          setIsAuthenticated(true);
        } catch (error) {
          console.error('Error fetching user data:', error);
          localStorage.removeItem('token');
          setIsAuthenticated(false);
        }
      }
      setLoading(false);
    };
    
    fetchUserData();
  }, []);

  const login = (userData) => {
    setIsAuthenticated(true);
    setUser(userData);
  };

  const logout = () => {
    setIsAuthenticated(false);
    setUser(null);
    localStorage.removeItem('token'); 
  };

  
  const showLoading = () => setLoading(true);
  const hideLoading = () => setLoading(false);

  return (
    <AuthContext.Provider value={{ isAuthenticated, user, login, logout }}>
      <LoadingContext.Provider value={{ loading, showLoading, hideLoading }}>
        {children}
      </LoadingContext.Provider>
    </AuthContext.Provider>
  );
};
